import React from 'react';
import './SideBar.css';
import { Collection, View, Icon, Text, Flex, Card } from '@aws-amplify/ui-react';
import { NavLink } from 'react-router-dom';
import Logo from '../Logo';
import { baseConfig, NavGroup } from '../../config';
import EyebrowGroupLabel from '../EyebrowGroupLabel';

export interface SidebarNavProps {
  navs?: NavGroup[];
}

const SideBarNav = ({ navs = [] }: SidebarNavProps) => {
  const activeClassName = 'active';

  return (
    <Flex direction="column" className="sidebar-nav">
      <Flex alignItems="center" padding="1rem" paddingBottom="0">
        <NavLink to="/">
          <Flex alignItems="center" gap="0.5rem">
            <View as="span" color="brand.primary.80" display="inline-flex">
              <Logo />
            </View>
            <Text as="span" className="sidebar-brand-mark">
              {baseConfig.headerText}
            </Text>
          </Flex>
        </NavLink>
      </Flex>
      {navs.map((group, groupIndex) => (
        <View key={groupIndex}>
          {group.eyebrow && (
            <View paddingLeft="xl" paddingTop="medium">
              <EyebrowGroupLabel>{group.eyebrow}</EyebrowGroupLabel>
            </View>
          )}
          <Collection type="list" items={group.items} alignItems="center" gap="xxs">
            {(navItem, index) => (
              <Card
                key={navItem.eventKey || index}
                minWidth="90%"
                backgroundColor="transparent"
                border="none"
                boxShadow="none"
                padding="xxs"
              >
                <NavLink
                  to={navItem.to}
                  className={({ isActive }) => (isActive ? activeClassName : undefined)}
                >
                  <Icon>{navItem.icon}</Icon>
                  {navItem.title}
                  {navItem.badge}
                </NavLink>
              </Card>
            )}
          </Collection>
        </View>
      ))}
    </Flex>
  );
};

export default SideBarNav;
